import { Link } from "react-router-dom";
import logoWhite from "@/assets/logo-white.png";
import { site } from "@/config/site";
import { track } from "@/lib/forms";

const cols = [
  {
    title: "Company",
    links: [
      { label: "Services", to: "/services" },
      { label: "Use Cases", to: "/use-cases" },
      { label: "Events", to: "/events" },
      { label: "Book a Call", to: "/book" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Meet Alfred", to: "/alfred" },
      { label: "Apps we've built", to: "/#apps" },
      { label: "Webinars", to: "/events" },
      { label: "Use Cases", to: "/use-cases" },
      { label: "Support", to: "/contact?type=support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
      { label: "Cookie Notice", to: "/cookies" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-footer text-slate-300 mt-20">
      <div className="container-atk py-16 lg:py-20">
        <div className="grid gap-10 lg:gap-12 lg:grid-cols-[1.4fr,1fr,1fr,1fr,1.1fr]">
          <div>
            <Link to="/" className="flex items-center gap-2.5" aria-label="AutomationTK home">
              <img src={logoWhite} alt="AutomationTK logo" width={40} height={40} className="h-10 w-auto" />
              <span className="font-extrabold text-white text-xl tracking-tight">AutomationTK</span>
            </Link>
            <p className="mt-5 text-[15px] text-slate-300/90 leading-relaxed max-w-sm">
              Practical workflow automation, AI-assisted systems and governed AI agents for operations-heavy teams.
            </p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-white text-[13px] font-semibold uppercase tracking-wider mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-[15px] text-slate-300 hover:text-white transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="text-white text-[13px] font-semibold uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${site.brandEmail}`} onClick={() => track("email_hello_click")} className="text-[15px] text-slate-300 hover:text-white transition-colors">{site.brandEmail}</a>
              </li>
              <li>
                <a href={`mailto:${site.supportEmail}`} onClick={() => track("email_support_click")} className="text-[15px] text-slate-300 hover:text-white transition-colors">{site.supportEmail}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 text-[13px] text-slate-400">
          © 2026 AutomationTK. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
